import { render, staticRenderFns } from "./RecepientsListMass.vue?vue&type=template&id=1a7e3773&"
import script from "./RecepientsListMass.vue?vue&type=script&lang=js&"
export * from "./RecepientsListMass.vue?vue&type=script&lang=js&"
import style0 from "./RecepientsListMass.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
